import {
  Companion_getInstance1a6q7ejsqzzhs as Companion_getInstance,
  _ReactiveState___get_raw__impl__92ipya10f5f3x6hwqt0 as _ReactiveState___get_raw__impl__92ipya,
} from './ReactiveState.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  equals2au1ep9vhcato as equals,
  createThis2j2avj17cvnv2 as createThis,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  Reactive1jy75v4li6ldv as Reactive,
  Companion_getInstancec4l82qvpwbuq as Companion_getInstance_0,
  beginUse146s8dwmfk72s as beginUse,
  Listenable3m4zqvjcbvczy as Listenable,
  get_state389x218zizu8a as get_state,
  getValue1utl0kjcx26k4 as getValue,
  ReactiveValue37mnzha3zo6xb as ReactiveValue,
} from './coreInterfaces.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { toList3jhuyej2anx2q as toList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var BaseReactiveClass;
function BaseReactive() {
  if (BaseReactiveClass === VOID) {
    class $ extends BaseListenable() {
      static gal(start, $box) {
        start = start === VOID ? Companion_getInstance().mah_1 : start;
        var $this = this.sam($box);
        $this.fal_1 = start;
        return $this;
      }
      pah(value) {
        if (!(_ReactiveState___get_raw__impl__92ipya(this.fal_1) === _ReactiveState___get_raw__impl__92ipya(value)) && !equals(this.fal_1, value)) {
          this.fal_1 = value;
          this.kal();
        }
      }
      qah() {
        return this.fal_1;
      }
    }
    initMetadataForClass($, 'BaseReactive', VOID, VOID, [Reactive(), BaseListenable()]);
    BaseReactiveClass = $;
  }
  return BaseReactiveClass;
}
var BaseListenableClass;
function BaseListenable() {
  if (BaseListenableClass === VOID) {
    class $ {
      static sam($box) {
        var $this = createThis(this, $box);
        $this.haj_1 = ArrayList().w();
        return $this;
      }
      ial() {
      }
      jal() {
      }
      tah(listener) {
        if (this.haj_1.i1()) {
          this.ial();
        }
        this.haj_1.v(listener);
        return () => {
          var tmp0 = this.haj_1;
          var tmp$ret$1;
          $l$block: {
            // Inline function 'kotlin.collections.indexOfFirst' call
            var index = 0;
            var _iterator__ex2g4s = tmp0.m1();
            while (_iterator__ex2g4s.n1()) {
              var item = _iterator__ex2g4s.o1();
              if (item === listener) {
                tmp$ret$1 = index;
                break $l$block;
              }
              index = index + 1 | 0;
            }
            tmp$ret$1 = -1;
          }
          var pos = tmp$ret$1;
          var tmp;
          if (!(pos === -1)) {
            this.haj_1.z3(pos);
            var tmp_0;
            if (this.haj_1.i1()) {
              this.jal();
              tmp_0 = Unit_instance;
            }
            tmp = tmp_0;
          }
          return Unit_instance;
        };
      }
      kal() {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = toList(this.haj_1).m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          $l$block: {
            try {
              element();
            } catch ($p) {
              if ($p instanceof Exception()) {
                var e = $p;
                if (e instanceof CancellationException()) {
                  break $l$block;
                }
                Companion_getInstance_0().xaj_1(e);
              } else {
                throw $p;
              }
            }
          }
        }
      }
    }
    protoOf($).iaj = beginUse;
    initMetadataForClass($, 'BaseListenable', VOID, VOID, [Listenable()]);
    BaseListenableClass = $;
  }
  return BaseListenableClass;
}
var BaseReactiveValueClass;
function BaseReactiveValue() {
  if (BaseReactiveValueClass === VOID) {
    class $ extends BaseListenable() {
      static vao(start, $box) {
        var $this = this.sam($box);
        $this.uao_1 = start;
        return $this;
      }
      mam(value) {
        if (!(this.uao_1 === value) && !equals(this.uao_1, value)) {
          this.uao_1 = value;
          this.kal();
        }
      }
      f2() {
        return this.uao_1;
      }
    }
    protoOf($).qah = get_state;
    protoOf($).nam = getValue;
    initMetadataForClass($, 'BaseReactiveValue', VOID, VOID, [ReactiveValue(), BaseListenable()]);
    BaseReactiveValueClass = $;
  }
  return BaseReactiveValueClass;
}
//region block: exports
export {
  BaseListenable as BaseListenable1u3g4s45l82o6,
  BaseReactiveValue as BaseReactiveValue1ggyqczzm31cy,
  BaseReactive as BaseReactive302n39o7i5yop,
};
//endregion

//# sourceMappingURL=abstracts.mjs.map
